import AppReducer from './app/reducer'
export default {
  AppReducer
}
